<div class="banner-container">
  <div class="banner">
    <img class="banner-image" [src]="getPictureItem(item)" alt="Banner" />
    <div class="banner-gradient"></div>

    <a
      *ngIf="isValidUrl(item.url)"
      class="banner-description"
      [attr.href]="isValidUrl(item.url) ? item.url : null"
      target="_blank"
      rel="noopener noreferrer"
    >
      <ng-container *ngTemplateOutlet="bannerContent; context: { item: item }"></ng-container>
    </a>

    <div
      *ngIf="!isValidUrl(item.url)"
      class="banner-description"
      (click)="navigate(item)"
    >
      <ng-container *ngTemplateOutlet="bannerContent; context: { item: item }"></ng-container>
    </div>

    <ng-template #bannerContent let-item="item">
      <div class="ribbon-container">
        <div *ngIf="isHome && item.benefit?.starred_home" class="ribbon-wrapper">
          <div class="ribbon">
            Beneficio destacado
            <span class="ribbon-tail"></span>
          </div>
        </div>
        <img
          *ngIf="item.benefit?.partner?.logo"
          [src]="item.benefit.partner.logo"
          alt="Logo del partner"
        />
      </div>

      <div class="benefit-description" *ngIf="item.benefit">
        <div
          class="benefitBox"
          [ngClass]="{ 'starred-benefit': item.benefit?.starred_home }"
        >
          <p>{{ item.benefit.category?.name || item.category?.name }}</p>

          <span *ngIf="item.benefit.typete !== '$'">
            {{ item.benefit.discount }}{{ item.benefit.typete }}
            {{ item.benefit.benefit_discount }}
          </span>

          <span *ngIf="item.benefit.typete === '$'">
            {{ item.benefit.typete }}{{ item.benefit.discount }}
            {{ item.benefit.benefit_discount }}
          </span>
        </div>
      </div>
    </ng-template>
  </div>
</div>
